/** 礼盒 */
export interface Box {
  type: 'lotteryLow' | 'lotteryMedium' | 'lotteryHigh'
  coin: number
  count: number
  id: string
  quality: number
  prop?: any
  refresh?: number
}

/** 圣诞礼盒数据 */
export interface LotteryData {
  /** 圣诞币数量 */
  coin: number
  low: Box
  medium: Box
  high: Box
}
/** 圣诞礼盒数据 */
export interface LotteryPreviewData {
  /** 圣诞币数量 */
  low: Box[] // 数组
  medium: Box[]
  high: Box[]
}
/** 刷新数据 */
export interface lotteryRefreshData {
  /** 圣诞币数量 */
  coin: number
  items: Box
}

export function getDefaultLotteryData(): LotteryData {
  return {
    coin: 0,
    high: {
      type: 'lotteryHigh',
      coin: 0,
      count: 0,
      id: '',
      quality: 1,
      refresh: 10,
    },
    medium: {
      type: 'lotteryMedium',
      coin: 0,
      count: 0,
      id: '',
      quality: 1,
      refresh: 10,
    },
    low: {
      type: 'lotteryLow',
      coin: 0,
      count: 0,
      id: '',
      quality: 1,
      refresh: 10,
    },
  }
}
export function getDefaultLotteryPreviewData(): LotteryPreviewData {
  return {
    low: [],
    medium: [],
    high: [],
  }
}

export const lotteryData: LotteryData = getDefaultLotteryData()
export const lotteryPreviewData: LotteryPreviewData =
  getDefaultLotteryPreviewData()
